export const urls = {
  VARATI_DELOVE_PREGLED: 'DokNarudzbine/narucivanje_delova_pregled',
  VARATI_DELOVE_FILTER: 'DokNarudzbine/narucivanje_delova_filter',
  VARATI_MASINE: 'Combo/vrati_masine_combo',
  GET_MASINE_ZA_KUPCA: 'Combo/vrati_masine_za_kupca',
  DODAVANJE_U_KORPU: 'DokNarudzbine/narucivanje_delova_dodavanje_u_korpu',
  KOLICINA_U_KORPI: 'DokNarudzbine/narucivanje_delova_kolicina_u_korpi',
  KOLICINA_ZA_DEO: 'DokNarudzbine/narucivanje_delova_vrati_kolicinu_detalji',
};
